<template>
  <div class="global-box">
    <div class="header" v-if="flutuation" />
    <div class="header" :class="{'flutuation': flutuation, 'diff': !complete}">
      <div class="content-box">
        <div
          class="logo"
          :class="{
            'diff': !complete,
            'pointer': $router.currentRoute.path !== '/'
          }"
          @click="routerDirect"
        >
          <img
            src="../assets/images/logo/brandRepresente.svg"
            :alt="$t('index.list_menu.alt_img')"
          >
        </div>
        <div class="menu-list" v-if="complete">
          <ul class="list">
            <li class="login">
              <a href="https://app.represente.com.br">
                <div>
                  {{$t('index.list_menu.login')}}
                </div>
              </a>
            </li>
            <li class="registrations">
              <router-link
                to="/registrations"
              >
                {{$t('index.list_menu.registrations')}}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header-session',
  props: {
    complete: {
      type: Boolean,
      default: true,
    },
    isFlutuation: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  data() {
    return {
      flutuation: false,
    };
  },
  methods: {
    updateScroll() {
      if (this.isFlutuation) {
        if (window.scrollY > 120) {
          this.flutuation = true;
        } else {
          this.flutuation = false;
        }
      }
    },
    routerDirect() {
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push({ path: '/' });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .global-box
    padding: 0 !important
    overflow: initial !important
  .header
    height: 74px
    background-color: $primary
    transition: all .5s
    z-index: 10
    padding: 8px 0
    display: flex
    align-items: center
    .content-box
      padding: 8px
    &.flutuation
      width: 100%
      height: 64px
      position: fixed
      top: 0
      box-shadow: 0px 3px 3px 0px $secundary
      background-color: $secundary
      .logo
        height: 48px
        width: 140px
      .menu-list .list .registrations
        background-color: $primary !important
    &.diff
      position: relative
      margin-bottom: 72px
      &::before
        content: ''
        width: 100%
        height: 80px
        position: absolute
        bottom: -36px
        left: 0
        background-color: $primary
        border-bottom: 1px solid $brand-twoo
        z-index: -1
        transform: skew(0,-3deg)
    .logo
      width: 150px
      height: 62px
      display: flex
      justify-content: center
      transition: all .4s
      img
        width: 92%
        height: auto
      &.diff
        margin: 0 auto
      &.pointer
        cursor: pointer
    .menu-list
      flex: 1
      display: flex
      flex-wrap: wrap
      .list
        width: 100%
        display: flex
        flex-wrap: wrap
        justify-content: flex-end
        li
          margin: 0 8px
          &.registrations, &.login
            border: 1px solid $brand-twoo
            padding: 2px 12px
            a
              color: $brand-twoo !important
              font-weight: 400
              text-transform: lowercase
          &.registrations
            background-color: $secundary
          &.login
            background-color: transparent
            border-top: none
            border-right: none
            border-left: none
            padding: 2px 4px
          @keyframes animateRegistrations
            0%
              transform: scale(1.0)
            100%
              transform: scale(1.05)
    @media (max-width: $widthTerciary)
      &.flutuation
        height: 74px
        display: flex
        align-items: center
      &.diff
        &::before
          transform: skew(0,-6deg)
      .registrations
        display: none
      .login
        border: 1px solid $brand-twoo
        background-color: $secundary
        padding: 2px 12px
</style>
